import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "vouchers-page" };
const _hoisted_2 = { class: "alert-message" };
const _hoisted_3 = { class: "vouchers-container" };
const _hoisted_4 = { class: "voucher-item-content" };
const _hoisted_5 = {
    key: 0,
    class: "voucher-logo"
};
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = { class: "voucher-info" };
const _hoisted_8 = { class: "voucher-name" };
const _hoisted_9 = { class: "voucher-meta" };
const _hoisted_10 = {
    key: 0,
    class: "badge removed"
};
const _hoisted_11 = {
    key: 1,
    class: "badge featured"
};
const _hoisted_12 = { class: "section-header" };
const _hoisted_13 = { class: "details-grid" };
const _hoisted_14 = { class: "form-section" };
const _hoisted_15 = { class: "form-group" };
const _hoisted_16 = { class: "form-group" };
const _hoisted_17 = { class: "form-group" };
const _hoisted_18 = { class: "form-section" };
const _hoisted_19 = { class: "form-group" };
const _hoisted_20 = ["value"];
const _hoisted_21 = { class: "form-group" };
const _hoisted_22 = { class: "form-group" };
const _hoisted_23 = { class: "form-section" };
const _hoisted_24 = { class: "checkbox-group" };
const _hoisted_25 = { class: "checkbox-label" };
const _hoisted_26 = { class: "checkbox-label" };
const _hoisted_27 = ["disabled"];
const _hoisted_28 = { class: "checkbox-label" };
const _hoisted_29 = { class: "checkbox-label" };
const _hoisted_30 = { class: "form-section" };
const _hoisted_31 = { class: "form-group" };
const _hoisted_32 = { class: "checkbox-label override-checkbox" };
const _hoisted_33 = { class: "form-group" };
const _hoisted_34 = ["disabled"];
const _hoisted_35 = { class: "form-section full-width" };
const _hoisted_36 = { class: "form-section full-width" };
const _hoisted_37 = { class: "form-section" };
const _hoisted_38 = { class: "form-group" };
const _hoisted_39 = { class: "form-group" };
const _hoisted_40 = { class: "form-group" };
const _hoisted_41 = { class: "form-section" };
const _hoisted_42 = { class: "form-group" };
const _hoisted_43 = { class: "form-group" };
const _hoisted_44 = { class: "form-section" };
const _hoisted_45 = { class: "form-group" };
const _hoisted_46 = { class: "form-group" };
const _hoisted_47 = { class: "form-group" };
const _hoisted_48 = { class: "form-section full-width" };
const _hoisted_49 = { class: "preview-grid" };
const _hoisted_50 = {
    key: 0,
    class: "preview-item"
};
const _hoisted_51 = ["src", "alt"];
const _hoisted_52 = {
    key: 1,
    class: "preview-item"
};
const _hoisted_53 = ["src", "alt"];
const _hoisted_54 = {
    key: 2,
    class: "preview-item"
};
const _hoisted_55 = {
    key: 1,
    class: "empty-state-large"
};
const _hoisted_56 = { class: "modal-body" };
const _hoisted_57 = {
    key: 0,
    class: "loading"
};
const _hoisted_58 = {
    key: 1,
    class: "report-grid"
};
const _hoisted_59 = {
    key: 0,
    class: "report-card"
};
const _hoisted_60 = { class: "report-item" };
const _hoisted_61 = { class: "value" };
const _hoisted_62 = { class: "report-item" };
const _hoisted_63 = { class: "value" };
const _hoisted_64 = { class: "report-item" };
const _hoisted_65 = { class: "value" };
const _hoisted_66 = { class: "report-item" };
const _hoisted_67 = { class: "value" };
const _hoisted_68 = { class: "report-item" };
const _hoisted_69 = { class: "value" };
const _hoisted_70 = {
    key: 1,
    class: "report-card"
};
const _hoisted_71 = { class: "report-item" };
const _hoisted_72 = { class: "value" };
const _hoisted_73 = { class: "report-item" };
const _hoisted_74 = { class: "value" };
const _hoisted_75 = { class: "report-item" };
const _hoisted_76 = { class: "value" };
const _hoisted_77 = { class: "report-item" };
const _hoisted_78 = { class: "value" };
const _hoisted_79 = { class: "report-item" };
const _hoisted_80 = { class: "value" };
const _hoisted_81 = { class: "report-item" };
const _hoisted_82 = { class: "value" };
import { ref, nextTick, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import AdminListSection from '@/admin/components/AdminListSection.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VouchersPage',
    setup(__props) {
        const admin = useAdmin();
        const vouchers = ref([]);
        const selectedVoucher = ref(null);
        const merchants = ref([]);
        const loading = ref(false);
        const showAlert = ref(false);
        const alertMessage = ref('');
        const alertVariant = ref('success');
        const showReportModal = ref(false);
        const loadingReport = ref(false);
        const discountReport = ref(null);
        const paymentReport = ref(null);
        const voucherDetailsSection = ref(null);
        function refreshVouchers() {
            loading.value = true;
            admin.getVouchers((data) => {
                vouchers.value = data || [];
                loading.value = false;
                if (vouchers.value.length > 0 && !selectedVoucher.value) {
                    selectVoucher(vouchers.value[0]);
                }
            });
        }
        function getMerchantsData() {
            admin.getMerchants((data) => {
                merchants.value = data || [];
            });
        }
        function selectVoucher(voucher) {
            selectedVoucher.value = JSON.parse(JSON.stringify(voucher));
            // On mobile, scroll to details section
            if (window.innerWidth <= 768) {
                nextTick(() => {
                    if (voucherDetailsSection.value) {
                        voucherDetailsSection.value.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                });
            }
        }
        function saveVoucher() {
            admin.updateVoucher(selectedVoucher.value.id, selectedVoucher.value, () => {
                showMessage('Voucher saved successfully');
                refreshVouchers();
            }, (error) => {
                showMessage(error || 'Failed to save voucher', 'error');
            });
        }
        function toggleReportModal() {
            showReportModal.value = !showReportModal.value;
            if (showReportModal.value) {
                loadReport();
            }
        }
        function loadReport() {
            loadingReport.value = true;
            discountReport.value = null;
            paymentReport.value = null;
            admin.getDiscountReport((data) => {
                discountReport.value = data;
            });
            admin.getPaymentReport((data) => {
                paymentReport.value = data;
                loadingReport.value = false;
            });
        }
        function handleImageError(event) {
            event.target.style.display = 'none';
        }
        function showMessage(message, variant = 'success') {
            alertMessage.value = message;
            alertVariant.value = variant;
            showAlert.value = true;
            if (variant !== 'error') {
                setTimeout(() => {
                    showAlert.value = false;
                }, 5000);
            }
        }
        onMounted(() => {
            refreshVouchers();
            getMerchantsData();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[74] || (_cache[74] = _createElementVNode("div", { class: "page-header" }, [
                    _createElementVNode("h1", null, "Voucher Administration"),
                    _createElementVNode("p", { class: "subtitle" }, "Manage and configure vouchers")
                ], -1)),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (showAlert.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["alert", `alert-${alertVariant.value}`])
                            }, [
                                _createElementVNode("span", _hoisted_2, _toDisplayString(alertMessage.value), 1),
                                _createElementVNode("button", {
                                    class: "alert-close",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (showAlert.value = false))
                                }, "✕")
                            ], 2))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(AdminListSection, {
                        title: "Vouchers",
                        items: vouchers.value,
                        "selected-id": selectedVoucher.value?.id,
                        loading: loading.value,
                        "search-placeholder": "Search vouchers...",
                        "empty-message": "No vouchers found",
                        "search-fields": ['merchant.name'],
                        onSelect: selectVoucher,
                        onRefresh: refreshVouchers
                    }, {
                        item: _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_4, [
                                (item.merchant && item.merchant.logoUrl)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createElementVNode("img", {
                                            src: item.merchant.logoUrl,
                                            alt: item.merchant.name,
                                            onError: handleImageError
                                        }, null, 40, _hoisted_6)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, _toDisplayString(item.merchant ? item.merchant.name : 'Unknown'), 1),
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["badge", { enabled: item.enabled, disabled: !item.enabled }])
                                        }, _toDisplayString(item.enabled ? 'Enabled' : 'Disabled'), 3),
                                        (item.removed)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Removed"))
                                            : _createCommentVNode("", true),
                                        (item.featured)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Featured"))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ])
                        ]),
                        _: 1
                    }, 8, ["items", "selected-id", "loading"]),
                    (selectedVoucher.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            ref_key: "voucherDetailsSection",
                            ref: voucherDetailsSection,
                            class: "voucher-details-section"
                        }, [
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("h2", null, _toDisplayString(selectedVoucher.value.merchant ? selectedVoucher.value.merchant.name : 'Voucher Details'), 1),
                                _createElementVNode("button", {
                                    class: "action-btn danger",
                                    onClick: toggleReportModal
                                }, " 📊 Report ")
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _cache[27] || (_cache[27] = _createElementVNode("h3", null, "Basic Information", -1)),
                                    _createElementVNode("div", _hoisted_15, [
                                        _cache[24] || (_cache[24] = _createElementVNode("label", null, "Name", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedVoucher.value.merchant.name) = $event)),
                                            disabled: "",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedVoucher.value.merchant.name]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                        _cache[25] || (_cache[25] = _createElementVNode("label", null, "ID", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedVoucher.value.id) = $event)),
                                            disabled: "",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedVoucher.value.id]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_17, [
                                        _cache[26] || (_cache[26] = _createElementVNode("label", null, "Slug", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((selectedVoucher.value.merchant.slug) = $event)),
                                            disabled: "",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedVoucher.value.merchant.slug]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                    _cache[32] || (_cache[32] = _createElementVNode("h3", null, "Configuration", -1)),
                                    _createElementVNode("div", _hoisted_19, [
                                        _cache[29] || (_cache[29] = _createElementVNode("label", null, "Merchant", -1)),
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((selectedVoucher.value.merchant.sysoMerchantId) = $event)),
                                            onChange: saveVoucher,
                                            class: "form-input"
                                        }, [
                                            _cache[28] || (_cache[28] = _createElementVNode("option", { value: null }, "None", -1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(merchants.value, (merchant) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: merchant.id,
                                                    value: merchant.id
                                                }, _toDisplayString(merchant.name), 9, _hoisted_20));
                                            }), 128))
                                        ], 544), [
                                            [_vModelSelect, selectedVoucher.value.merchant.sysoMerchantId]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                        _cache[30] || (_cache[30] = _createElementVNode("label", null, "Categories", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((selectedVoucher.value.merchant.categories) = $event)),
                                            onChange: saveVoucher,
                                            class: "form-input"
                                        }, null, 544), [
                                            [_vModelText, selectedVoucher.value.merchant.categories]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_22, [
                                        _cache[31] || (_cache[31] = _createElementVNode("label", null, "Delivery Method", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((selectedVoucher.value.deliveryMethod) = $event)),
                                            disabled: "",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedVoucher.value.deliveryMethod]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_23, [
                                    _cache[37] || (_cache[37] = _createElementVNode("h3", null, "Status", -1)),
                                    _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("label", _hoisted_25, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((selectedVoucher.value.active) = $event)),
                                                onChange: saveVoucher
                                            }, null, 544), [
                                                [_vModelCheckbox, selectedVoucher.value.active]
                                            ]),
                                            _cache[33] || (_cache[33] = _createElementVNode("span", null, "Active", -1))
                                        ]),
                                        _createElementVNode("label", _hoisted_26, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((selectedVoucher.value.enabled) = $event)),
                                                disabled: selectedVoucher.value.removed,
                                                onChange: saveVoucher
                                            }, null, 40, _hoisted_27), [
                                                [_vModelCheckbox, selectedVoucher.value.enabled]
                                            ]),
                                            _cache[34] || (_cache[34] = _createElementVNode("span", null, "Enabled", -1))
                                        ]),
                                        _createElementVNode("label", _hoisted_28, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((selectedVoucher.value.removed) = $event)),
                                                disabled: ""
                                            }, null, 512), [
                                                [_vModelCheckbox, selectedVoucher.value.removed]
                                            ]),
                                            _cache[35] || (_cache[35] = _createElementVNode("span", null, "Removed", -1))
                                        ]),
                                        _createElementVNode("label", _hoisted_29, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((selectedVoucher.value.featured) = $event)),
                                                onChange: saveVoucher
                                            }, null, 544), [
                                                [_vModelCheckbox, selectedVoucher.value.featured]
                                            ]),
                                            _cache[36] || (_cache[36] = _createElementVNode("span", null, "Featured", -1))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                    _cache[40] || (_cache[40] = _createElementVNode("h3", null, "Discount %", -1)),
                                    _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("label", _hoisted_32, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((selectedVoucher.value.manualOverride) = $event)),
                                                onChange: saveVoucher
                                            }, null, 544), [
                                                [_vModelCheckbox, selectedVoucher.value.manualOverride]
                                            ]),
                                            _cache[38] || (_cache[38] = _createElementVNode("span", null, "Manual Override", -1))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_33, [
                                        _cache[39] || (_cache[39] = _createElementVNode("label", null, "Discount Percentage", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((selectedVoucher.value.discountPercentage) = $event)),
                                            disabled: !selectedVoucher.value.manualOverride,
                                            onChange: saveVoucher,
                                            class: "form-input"
                                        }, null, 40, _hoisted_34), [
                                            [_vModelText, selectedVoucher.value.discountPercentage]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                    _cache[41] || (_cache[41] = _createElementVNode("h3", null, "Description", -1)),
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((selectedVoucher.value.description) = $event)),
                                        disabled: "",
                                        class: "form-textarea"
                                    }, null, 512), [
                                        [_vModelText, selectedVoucher.value.description]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                    _cache[42] || (_cache[42] = _createElementVNode("h3", null, "Terms", -1)),
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((selectedVoucher.value.terms) = $event)),
                                        disabled: "",
                                        class: "form-textarea"
                                    }, null, 512), [
                                        [_vModelText, selectedVoucher.value.terms]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_37, [
                                    _cache[46] || (_cache[46] = _createElementVNode("h3", null, "Amounts", -1)),
                                    _createElementVNode("div", _hoisted_38, [
                                        _cache[43] || (_cache[43] = _createElementVNode("label", null, "Lower Amount", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((selectedVoucher.value.lowerAmount) = $event)),
                                            disabled: "",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedVoucher.value.lowerAmount]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_39, [
                                        _cache[44] || (_cache[44] = _createElementVNode("label", null, "Upper Amount", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((selectedVoucher.value.upperAmount) = $event)),
                                            disabled: "",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedVoucher.value.upperAmount]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_40, [
                                        _cache[45] || (_cache[45] = _createElementVNode("label", null, "Allowed Amounts", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((selectedVoucher.value.allowedAmounts) = $event)),
                                            disabled: "",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedVoucher.value.allowedAmounts]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                    _cache[49] || (_cache[49] = _createElementVNode("h3", null, "Availability", -1)),
                                    _createElementVNode("div", _hoisted_42, [
                                        _cache[47] || (_cache[47] = _createElementVNode("label", null, "In Store", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((selectedVoucher.value.inStore) = $event)),
                                            disabled: "",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedVoucher.value.inStore]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_43, [
                                        _cache[48] || (_cache[48] = _createElementVNode("label", null, "Online", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((selectedVoucher.value.online) = $event)),
                                            disabled: "",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedVoucher.value.online]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_44, [
                                    _cache[53] || (_cache[53] = _createElementVNode("h3", null, "Visual Configuration", -1)),
                                    _createElementVNode("div", _hoisted_45, [
                                        _cache[50] || (_cache[50] = _createElementVNode("label", null, "Card URL", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((selectedVoucher.value.cardUrl) = $event)),
                                            disabled: "",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedVoucher.value.cardUrl]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_46, [
                                        _cache[51] || (_cache[51] = _createElementVNode("label", null, "Logo URL", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((selectedVoucher.value.merchant.logoUrl) = $event)),
                                            disabled: "",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedVoucher.value.merchant.logoUrl]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_47, [
                                        _cache[52] || (_cache[52] = _createElementVNode("label", null, "Card Colour", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "color",
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((selectedVoucher.value.cardColour) = $event)),
                                            onChange: saveVoucher,
                                            class: "color-input"
                                        }, null, 544), [
                                            [_vModelText, selectedVoucher.value.cardColour]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_48, [
                                    _cache[57] || (_cache[57] = _createElementVNode("h3", null, "Previews", -1)),
                                    _createElementVNode("div", _hoisted_49, [
                                        (selectedVoucher.value.cardUrl)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                _cache[54] || (_cache[54] = _createElementVNode("div", { class: "preview-label" }, "Card", -1)),
                                                _createElementVNode("img", {
                                                    src: selectedVoucher.value.cardUrl,
                                                    alt: selectedVoucher.value.merchant.name,
                                                    class: "preview-image",
                                                    onError: handleImageError
                                                }, null, 40, _hoisted_51)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (selectedVoucher.value.merchant && selectedVoucher.value.merchant.logoUrl)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                _cache[55] || (_cache[55] = _createElementVNode("div", { class: "preview-label" }, "Logo", -1)),
                                                _createElementVNode("img", {
                                                    src: selectedVoucher.value.merchant.logoUrl,
                                                    alt: selectedVoucher.value.merchant.name,
                                                    class: "preview-image",
                                                    onError: handleImageError
                                                }, null, 40, _hoisted_53)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (selectedVoucher.value.cardColour)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                                _cache[56] || (_cache[56] = _createElementVNode("div", { class: "preview-label" }, "Color", -1)),
                                                _createElementVNode("div", {
                                                    class: "color-preview",
                                                    style: _normalizeStyle({ backgroundColor: selectedVoucher.value.cardColour })
                                                }, null, 4)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ])
                        ], 512))
                        : (_openBlock(), _createElementBlock("div", _hoisted_55, _cache[58] || (_cache[58] = [
                            _createElementVNode("p", null, "Select a voucher to view details", -1)
                        ])))
                ]),
                (showReportModal.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "modal-overlay",
                        onClick: toggleReportModal
                    }, [
                        _createElementVNode("div", {
                            class: "modal-dialog",
                            onClick: _cache[23] || (_cache[23] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("div", { class: "modal-header" }, [
                                _cache[59] || (_cache[59] = _createElementVNode("h3", null, "Vouchers Summary Report", -1)),
                                _createElementVNode("button", {
                                    class: "close-btn",
                                    onClick: toggleReportModal
                                }, "✕")
                            ]),
                            _createElementVNode("div", _hoisted_56, [
                                (loadingReport.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, _cache[60] || (_cache[60] = [
                                        _createElementVNode("div", { class: "spinner" }, null, -1),
                                        _createElementVNode("p", null, "Loading report...", -1)
                                    ])))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                        (discountReport.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                                _cache[66] || (_cache[66] = _createElementVNode("h4", null, "Discounts", -1)),
                                                _createElementVNode("div", _hoisted_60, [
                                                    _cache[61] || (_cache[61] = _createElementVNode("span", { class: "label" }, "Total Vouchers Available:", -1)),
                                                    _createElementVNode("span", _hoisted_61, _toDisplayString(discountReport.value.totalVouchersAvailable), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_62, [
                                                    _cache[62] || (_cache[62] = _createElementVNode("span", { class: "label" }, "Total Vouchers Purchased:", -1)),
                                                    _createElementVNode("span", _hoisted_63, _toDisplayString(discountReport.value.totalVouchersPurchased), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_64, [
                                                    _cache[63] || (_cache[63] = _createElementVNode("span", { class: "label" }, "Sum Of Purchased Value:", -1)),
                                                    _createElementVNode("span", _hoisted_65, "£" + _toDisplayString(discountReport.value.sumOfPurchasedVouchersValue), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_66, [
                                                    _cache[64] || (_cache[64] = _createElementVNode("span", { class: "label" }, "Liability:", -1)),
                                                    _createElementVNode("span", _hoisted_67, "£" + _toDisplayString(discountReport.value.liability), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_68, [
                                                    _cache[65] || (_cache[65] = _createElementVNode("span", { class: "label" }, "Float Balance:", -1)),
                                                    _createElementVNode("span", _hoisted_69, "£" + _toDisplayString(discountReport.value.floatBalance), 1)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (paymentReport.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                                _cache[73] || (_cache[73] = _createElementVNode("h4", null, "Payments", -1)),
                                                _createElementVNode("div", _hoisted_71, [
                                                    _cache[67] || (_cache[67] = _createElementVNode("span", { class: "label" }, "Total Payments Paid:", -1)),
                                                    _createElementVNode("span", _hoisted_72, _toDisplayString(paymentReport.value.totalPaymentsPaid), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_73, [
                                                    _cache[68] || (_cache[68] = _createElementVNode("span", { class: "label" }, "Total Amount Paid:", -1)),
                                                    _createElementVNode("span", _hoisted_74, "£" + _toDisplayString((paymentReport.value.totalAmountInPencePaid / 100).toFixed(2)), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_75, [
                                                    _cache[69] || (_cache[69] = _createElementVNode("span", { class: "label" }, "Total Fees Paid:", -1)),
                                                    _createElementVNode("span", _hoisted_76, "£" + _toDisplayString((paymentReport.value.totalFeesInPencePaid / 100).toFixed(2)), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_77, [
                                                    _cache[70] || (_cache[70] = _createElementVNode("span", { class: "label" }, "Total Payments Unpaid:", -1)),
                                                    _createElementVNode("span", _hoisted_78, _toDisplayString(paymentReport.value.totalPaymentsUnpaid), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_79, [
                                                    _cache[71] || (_cache[71] = _createElementVNode("span", { class: "label" }, "Total Amount Unpaid:", -1)),
                                                    _createElementVNode("span", _hoisted_80, "£" + _toDisplayString((paymentReport.value.totalAmountInPenceUnpaid / 100).toFixed(2)), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_81, [
                                                    _cache[72] || (_cache[72] = _createElementVNode("span", { class: "label" }, "Total Fees Unpaid:", -1)),
                                                    _createElementVNode("span", _hoisted_82, "£" + _toDisplayString((paymentReport.value.totalFeesInPenceUnpaid / 100).toFixed(2)), 1)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]))
                            ]),
                            _createElementVNode("div", { class: "modal-actions" }, [
                                _createElementVNode("button", {
                                    class: "action-btn secondary",
                                    onClick: toggleReportModal
                                }, "Close")
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
